/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import OrgAppDeviceForm from './OrgAppDeviceForm';
import { getAllOrgApplicationDevices } from '../../../../../../../../store/reducers/organization/orgApplicationDevices/orgApplicationDevicesAction';
import { createOrgApplicationDevice } from '../../../../../../../../services/organization/OrgApplicationDevices';

const OrgAppDeviceCreation = ({ handleClose }) => {
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, deviceID, roleID, organizationApplicationID }, { setSubmitting }) => {
        try {
            await createOrgApplicationDevice({ organizationID, deviceID, roleID, organizationApplicationID })
            await dispatch(getAllOrgApplicationDevices()).unwrap();
            setSubmitting(false);
            handleClose();
            toast.success('Organization Application Device was registred successfully');

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setSubmitting(false);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Device Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid : '',
                    organizationApplicationID: '',
                    roleID: '',
                    deviceID: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    organizationApplicationID: Yup.string().required('Organization Application is required.'),
                    roleID: Yup.string().required('Role is required.'),
                    deviceID: Yup.string().required('Device is required.'),
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgAppDeviceForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAppDeviceCreation;
